import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_38_95_1M_12_99_EN_CLUSTER',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_38_95_1m_12_99_usd',
			GBP: 'simple_premium_1m_38_95_1m_12_99_gbp',
			CAD: 'simple_premium_1m_49_99_1m_15_99_cad',
			AUD: 'simple_premium_1m_49_99_1m_19_99_aud',
		},
		primer: 'prd_mcwC6D1Wx2lO',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 12.99,
			GBP: 12.99,
			CAD: 15.99,
			AUD: 19.99,
		},
		originalPriceMap: {
			USD: 38.95,
			GBP: 38.95,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			GBP: 38.95,
			CAD: 49.99,
			AUD: 49.99,
		},
	},
}
